import type { ReactNode } from 'react'
import { Button } from './button.tsx'

export function LoadingState({ label = 'Carregando este momento…' }: { label?: string }) {
  return (
    <div className="status-card" role="status" aria-live="polite">
      <span className="loader" aria-hidden="true" />
      <p>{label}</p>
    </div>
  )
}

export function ErrorState({ retry, children }: { retry: () => void; children?: ReactNode }) {
  return (
    <div className="status-card status-card--error" role="alert">
      <h2>O caminho ficou encoberto</h2>
      <p>{children ?? 'Não conseguimos buscar o conteúdo agora.'}</p>
      <Button type="button" onClick={retry}>
        Tentar novamente
      </Button>
    </div>
  )
}

export function EmptyState({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div className="status-card">
      <h2>{title}</h2>
      <p>{children}</p>
    </div>
  )
}
